export default function (initialDataInteractor, data) {
  let questionnaireFound = false;

  initialDataInteractor.data.questionnaires.forEach(questionnaire => {
    if (questionnaire['id'] == data['id']) {
      questionnaireFound = true;
      Object.assign(questionnaire, data);
    }
  });

  if (!questionnaireFound) {
    initialDataInteractor.data.questionnaires.push(Object.assign({}, data));
  }

}